import { render, staticRenderFns } from "./reference-get-behavioural.vue?vue&type=template&id=4bb9d14c&scoped=true&"
import script from "./reference-get-behavioural.vue?vue&type=script&lang=js&"
export * from "./reference-get-behavioural.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb9d14c",
  null
  
)

export default component.exports